<template>
    <div class="">
      <v-img
        class="image_logo"
        width="250px"
        src="../../assets/logo.svg"
      ></v-img>
      <v-img
        class="image_sologan"
        width="240px"
        src="../../assets/sologan.svg"
      ></v-img>
    </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },

}
</script>
<style scoped>
.image_logo {
  position: relative;
}
.image_sologan {
  position: relative;
  top: -40px;
  padding-left: 5px;
}
</style>
